<template>
  <form data-vv-scope="CalendarEvent">
      <div class="flex flex-wrap -mx-2">
      <div class="sm:w-1/2 w-full px-2 mb-2">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            v-model="schedule_start_date"
            placeholder="Schedule Start Date"
            data-vv-name="coursestart"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.coursestart')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.coursestart") }}
        </div>
      </div>
     
      <div class="sm:w-1/2 w-full px-2 mb-2">
        <!-- {{event.course_start_time}} -->
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
           :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            data-vv-name="courseenddate"
            v-model="schedule_end_date"
            placeholder="Schedule End"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.courseenddate')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.courseenddate") }}
        </div>
      </div>
    
    </div>
    <!-- <input
    v-model="event.eventTextColor"
      class="w-full mb-2"
      type="color"
    /> -->
   
    <content-component v-model="description"
    label="Add Description"
    ></content-component>
    <!-- {{attachCLientList}} -->
    <div class="mt-4 text-right">
      <vs-button type="border">Cancel</vs-button>
      <vs-button class="ml-2" @click="saveEvent()" v-if="!editingObject">Save</vs-button>
            <vs-button class="ml-2" @click="saveEvent()" v-else>Update</vs-button>

    </div>
  </form>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import vSelect from 'vue-select'
import { createHolidayApi, UpdateGeneralEventApi } from '@/api/schedulerApi'
import { eventMixin } from '../mixins/eventMixin'

export default {
  components: {
    flatPickr,
    ContentComponent,
    vSelect
  },
  props: {
    startDate: {},
    endDate: {},
    editingObject: {
      type: Object,
      default: null
    }
  },
  mixins: [eventMixin],
  data () {
    return {
      
      id: null,
      schedule_start_date: null,
      schedule_end_date: null,
      description: null,
      schedule_from_time: null,
      schedule_to_time: null,
      eventTypePicked: null,
      colour_code: '#d50000',
      all_day_event: true,
    
      activeIndex: undefined,
     
      configdateTimePickerTest: {
        altInput: true,
        altFormat: 'j F, Y',
        // dateFormat: 'Y-m-d',
        wrap: true,
        dateFormat: 'Y-m-d',
        minDate:new Date()
      },
      configTime: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        dateFormat: 'H:i',
        wrap: true
      }
    }
  },
  created () {

    this.schedule_start_date = new Date(this.startDate)
    this.schedule_end_date = new Date(this.endDate)
    if (this.editingObject) {
     
      this.schedule_start_date = new Date(this.editingObject.start_hour)
      this.schedule_end_date = new Date(this.editingObject.end_hour)

      /* this.schedule_from_time = this.editingObject.schedule_from_time
      this.schedule_to_time = this.editingObject.schedule_to_time */
      this.description = this.editingObject.description
      this.all_day_event =  true
          

      
    }
   
   
    // 
  },
  /* beforeDestroy () {
    this.editingObject = null
  },
   */
  mounted () {
    /* this.event.course_start = this.startDate
    this.event.course_end = this.endDate */
  },
  methods: {
    saveEvent () {

      // 
        
      this.$validator.validateAll('CalendarEvent').then((valid) => {
        
        if (valid) {
          const customer_id = this.$store.getters.customerId
          
          const user_id = JSON.parse(localStorage.getItem('userInfo')).id
          const payload = [
            {
              customer_id,
              user_id,
              id:this.editingObject ? this.editingObject.id : null,
              calendar_year :new Date(this.schedule_start_date).getFullYear(),
              start_hour: this.schedule_start_date,
              end_hour: this.schedule_end_date,
              description: this.description
            }
          ]
          
          const checkingDateToday = this.validateTodayDate(new Date(), new Date(this.schedule_start_date))
          const hasCheckingStartEndDate = this.validateTodayDate(new Date(this.schedule_start_date), new Date(this.schedule_end_date))

          if (checkingDateToday <= 0 && hasCheckingStartEndDate <= 0) {
            this.savingEvent(payload)
          } else {
            let message = ''
            
            if (checkingDateToday > 0) {
              message = 'Event can not be scheduled on a past date'
            } else if (hasCheckingStartEndDate > 0) {
              message = 'Start Date must be less than end date'
            }
            this.showSuccessMessage('Error', `${message}`, 'danger')
          }
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
        
      })
     
    },
    async savingEvent (requestParameter) {
      try {
        const customer_id = this.$store.getters.customerId
        
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id
        const payload = {
          updateField:{
            holidays:requestParameter
          }
        }
        
        const data = await createHolidayApi(user_id, customer_id, payload)
        this.$emit('saveEventEmit')
        
      } catch (error) {
        
      }
    }
  }
}
</script>

<style>
.cstm-flat-pickr-holder {
  position: relative;
}
.cstm-flat-pickr-holder .material-icons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  cursor: pointer;
}
</style>